module.exports = __webpack_public_path__ + "static/img/corgauge.ffedc9d.png";


//////////////////
// WEBPACK FOOTER
// ./static/corgauge.png
// module id = hMrN
// module chunks = 1